'use client';

import { useEffect } from 'react';

/**
 * ルートレベルのグローバルエラーバウンダリ
 *
 * 目的:
 * - layout.tsx を含むルートで発生したクライアントサイド例外を捕捉する
 * - 「Application error: a client-side exception has occurred」を防ぎ、
 *   ユーザーにリトライ可能なフォールバックUIを表示する
 *
 * 備考:
 * - ルートレイアウトを置き換えるため、html/body タグを必ず含める
 * - 本番モードでのみ有効（開発時は Next.js のオーバーレイが表示される）
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Global Error Boundary]', error);
  }, [error]);

  return (
    <html lang='ja'>
      <body className='antialiased'>
        <div className='flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6'>
          <h1 className='mb-4 text-2xl font-bold text-gray-800'>
            申し訳ございません。問題が発生しました
          </h1>
          <p className='mb-8 max-w-md text-center text-gray-600'>
            一時的な不具合の可能性があります。ページを再読み込みするか、
            しばらく時間をおいて再度お試しください。
          </p>
          <button
            onClick={reset}
            className='rounded-full bg-primary px-8 py-3 font-bold text-white shadow-sm transition-colors hover:bg-primary/90'
          >
            再試行する
          </button>
        </div>
      </body>
    </html>
  );
}
